module.exports = __webpack_public_path__ + "static/media/rec-benefit-bg.7b9fbd62.png";